import { ProfilerOnRenderCallback } from 'react';

export const useProfiler = (componentName: string): ProfilerOnRenderCallback => {
  return (
    id,
    phase,
    actualDuration,
    baseDuration,
    startTime,
    commitTime
  ) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(`[${componentName}] ${id}:`, {
        phase,
        actualDuration: Math.round(actualDuration),
        baseDuration: Math.round(baseDuration),
        startTime: Math.round(startTime),
        commitTime: Math.round(commitTime),
      });
    }
  };
}; 